import React, { memo, useRef } from "react";

import {
  getTableNavStore,
  StoreContext,
} from "src/base-components/EditorTable/stores";

/**
 * Store context provider for the editor table. As each table instance
 * requires its own store, this component should be wrapped around outside the table
 * component.
 */
export const EditorTableStoreProvider = memo(
  ({ children }: { children: React.ReactNode }) => {
    const store = useRef(getTableNavStore());
    return <StoreContext value={store.current}>{children}</StoreContext>;
  },
);
